import api from './api';
import type { DashboardMetrics, BarberShop } from '../types/admin';

export const getAdminMetrics = async (): Promise<DashboardMetrics> => {
  const response = await api.get('/admin/metrics');
  return response.data;
};

export const getBarberShops = async (): Promise<BarberShop[]> => {
  const response = await api.get('/admin/shops');
  return response.data;
};

export const createBarberShop = async (shopData: Partial<BarberShop>) => {
  const response = await api.post('/admin/shops', shopData);
  return response.data;
};

export const updateBarberShop = async (id: number, shopData: Partial<BarberShop>) => {
  const response = await api.put(`/admin/shops/${id}`, shopData);
  return response.data;
};

export const adminLogin = async (credentials: { email: string; password: string }) => {
  // Create URLSearchParams for form-urlencoded format
  const formData = new URLSearchParams();
  formData.append('username', credentials.email);
  formData.append('password', credentials.password);
  formData.append('grant_type', 'password');
  formData.append('scope', 'admin');

  console.log('Attempting admin login with:', credentials.email);

  try {
    // Use the token endpoint with admin scope
    const response = await api.post('/token', formData.toString(), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    console.log('Admin login successful:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('Admin login error:', error);
    if (error.response) {
      console.error('Error response:', {
        status: error.response.status,
        data: error.response.data
      });
    }
    throw error;
  }
}; 